<script>
	import { pageOffset } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';

	let _fish;
	let inView = false;
	let start = 0;
	let scrollDirectionDown = true;
	let scrolledBefore = 0;
	export let direction = 'ltr';
	export let size;
	export let left;
	export let top;
	export let speedMultiplier;
	let swimRotation;

	let animation = (value) => {
		animateElement(value, _fish, (currentPageOffset) => {
			if (!inView) {
				start = currentPageOffset;
				inView = true;
			}
			scrollDirectionDown = scrolledBefore < currentPageOffset;
			scrolledBefore = currentPageOffset;
			const elmentInViewPercentage = (currentPageOffset - start) * 100 / window.innerHeight;

			_fish.style.transform = `translateX(${direction === 'ltr' ? '' : '-'}${(elmentInViewPercentage * 0.5 * speedMultiplier)}vw) rotate(${scrollDirectionDown ? swimRotation.down : swimRotation.up})`;
		});
	};

	function getOffsetTop(element) {
		if (element.offsetParent) {
			return element.offsetTop + getOffsetTop(element.offsetParent);
		}
		return element.offsetTop || 0;
	}


	let prepareScene = () => {
		if (!_fish) {
			requestAnimationFrame(prepareScene);
			return;
		}

		swimRotation = {
			down: direction === 'ltr' ? '180deg' : '0deg',
			up: direction === 'ltr' ? '0deg' : '180deg',
		};

		pageOffset.subscribe(animation);
	};

	prepareScene();

</script>

<style>
	svg {
		position: absolute;
		height: auto;
	}
</style>

<svg bind:this={_fish} style="width: {size}; left: {left}; top: {top}" fill="none" height="74" viewBox="0 0 184 74" width="184" xmlns="http://www.w3.org/2000/svg"><g fill="#5a97c3"><path d="m146.411 36.6343 36.594 36.3072v-72.9415z"/><path d="m109.434.0590066 36.503 36.5432934-36.503 36.5433-36.5038-36.5433z"/><path d="m36.5298.161052 36.5035 36.543248-36.5035 36.5433-36.5034328-36.5433z"/></g></svg>

